import { createSlice } from "@reduxjs/toolkit";
// import Immu from "utils/immu-util"
import { handleErrorStopLoading, handleLoading } from "redux/redux-util";
import { DefaultPaginable, routerChangeAction, Routes } from "const";
import Immu from "utils/immu-util";
import moment from "moment-timezone";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
  loading: false,
  fetchingDetail: false,
  histories: [],
  filterTransactionDate: [moment().subtract(3, "month"), moment()],
  transactionType: "All",
  paginable: { ...DefaultPaginable },
  endPaging: false,
  total: 0,
};

const slice = createSlice({
  initialState,
  name: "secondaryHistories",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      state.prevPathname = state.currPathname;
      state.currPathname = payload.location.pathname;
      state.goBackFromCustomerInfoPage = state.prevPathname === Routes.Register.CustomerInfo;
    });
  },
  reducers: {
    getHistory: handleLoading,
    getHistorySuccess: (state, action) => {
      state.loading = false;
      state.histories = action.payload.histories;
      // state.histories = [...state.histories, ...action.payload.histories]
      state.total = action.payload.total;
      state.paginable = action.payload.paginable;
      if (state.histories.length >= action.payload.total) {
        state.endPaging = true;
      }
    },
    getHistoryFailure: handleErrorStopLoading,

    reset: (state, action) => {
      const skipReset = state.goBackFromCustomerInfoPage;
      if (skipReset) return state;

      return action.payload.hard
        ? cloneDeep(initialState)
        : {
            ...cloneDeep(initialState),
            filterTransactionDate: state.filterTransactionDate,
          };
    },

    fetchingHistoryDetail: (state) => {
      state.fetchingDetail = true;
    },
    getHistoryDetail: () => {},
    getHistoryDetailSuccess: (state, action) => {
      state.fetchingDetail = false;
      state.histories = Immu.merge(state.histories, {
        path: `[[transactionNo:${action.payload.transactionNo}]]`,
        state: { ...action.payload, fetched: true },
      });
    },
    getHistoryDetailFailure: (state, action) => {
      state.fetchingDetail = false;
    },

    changeTransactionType: (state, action) => {
      state.transactionType = action.payload;
    },

    filterTransactionDateChange: (state, action) => {
      state.filterTransactionDate = action.payload;
      state.histories = [];
      state.paginable = { ...DefaultPaginable };
      state.endPaging = false;
      state.total = 0;
    },

    resendEmail: handleLoading,
    resendEmailSuccess: (state) => {
      state.loading = false;
    },
    resendEmailFailure: handleErrorStopLoading,
  },
});

export const {
  getHistory,
  getHistorySuccess,
  getHistoryFailure,
  getHistoryDetail,
  getHistoryDetailSuccess,
  getHistoryDetailFailure,
  changeTransactionType,
  filterTransactionDateChange,
  fetchingHistoryDetail,
  resendEmail,
  resendEmailSuccess,
  resendEmailFailure,
  reset,
} = slice.actions;

export default slice.reducer;
